import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AnimateOnScrollDirective } from './animate-on-scroll/animate-on-scroll.directive';
import { AutoGrowDirective } from './auto-grow/auto-grow.directive';
import { ControlValueAccessorDirective } from './control-value-accessor/control-value-accessor.directive';
import { HideDirective } from './hide/hide.directive';
import { RepeatDirective } from './repeat/repeat.directive';
import { TaggingDirective } from './tagging/tagging.directive';
import { VisibilityDirective } from './visibility/visibility.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    AnimateOnScrollDirective,
    AutoGrowDirective,
    ControlValueAccessorDirective,
    HideDirective,
    RepeatDirective,
    TaggingDirective,
    VisibilityDirective,
  ],
  exports: [
    AnimateOnScrollDirective,
    AutoGrowDirective,
    ControlValueAccessorDirective,
    RepeatDirective,
    HideDirective,
    TaggingDirective,
    VisibilityDirective,
  ],
})
export class DirectivesModule {}
